import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tt-table-trash-2",
  "use": "icon-tt-table-trash-2-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol viewBox=\"0 0 28 28\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-tt-table-trash-2\">\n<path d=\"M21 9L20.1327 21.1425C20.0579 22.1891 19.187 23 18.1378 23H9.86224C8.81296 23 7.94208 22.1891 7.86732 21.1425L7 9M12 13V19M16 13V19M17 9V6C17 5.44772 16.5523 5 16 5H12C11.4477 5 11 5.44772 11 6V9M6 9H22\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol